import { render, staticRenderFns } from "./SubscriptionItem.vue?vue&type=template&id=56f89c47&scoped=true"
import script from "./SubscriptionItem.vue?vue&type=script&lang=js"
export * from "./SubscriptionItem.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionItem.vue?vue&type=style&index=0&id=56f89c47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f89c47",
  null
  
)

export default component.exports